import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { attribute } from "../../Services/ShowModal/ShowModal";

// Models
interface product_attribute {
    name: string;
    value: string;
}

export interface showMaterial {
    name: string;
    description: string;
    serial_number: string;
    attributes: attribute[];
    product_attributes?: product_attribute[];
}

// Show material state
export interface showMaterialState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showMaterial;
}

const initialShowMaterialState: showMaterialState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {
        name: "",
        description: "",
        serial_number: "",
        attributes: []
    }
}

// Show material slice
export const showMaterialSlice = createSlice({
    name: 'show_material',
    initialState: initialShowMaterialState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setData: (state, { payload }: PayloadAction<showMaterial>) => {
            state.data = { ...state.data, ...payload }
        },
        setIsOpen: (state, { payload }: PayloadAction<{ id: number, isOpen: boolean, product_attributes?: product_attribute[] }>) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
            if (payload.product_attributes)
                state.data.product_attributes = payload.product_attributes
        },
    }
})